<app-combo-box
	placeholder="Search FIT"
	[sourceItems]="service.searchItems"
	[minChars]="1"
	[compactMode]="compactMode"
></app-combo-box>
